var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM2CLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.432389 19.0528L0.343689 19.7243H18.9598L19.1705 19.0528H0.432389Z",
    fill: "#78BA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.582535 17.7628L0.493835 18.4343H19.11L19.3207 17.7628H0.582535Z",
    fill: "#FBB900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166315 20.351L0 21.0001L18.6162 20.9889L18.8379 20.351H0.166315Z",
    fill: "#0769B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2699 3.6595H4.856C4.54554 3.6595 4.29053 3.41329 4.29053 3.09994C4.29053 3.06637 4.29053 3.0216 4.30162 2.98803L4.74512 0.470027C4.78947 0.20144 5.02231 0 5.2995 0H19.2921C20.2346 0 21.0107 0.783379 20.9996 1.73462C20.9996 1.80177 20.9996 1.86892 20.9885 1.93606L20.9774 2.12631C20.8777 2.99922 20.1459 3.6595 19.2699 3.6595Z",
    fill: "#006AB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7198 10.3182H3.13745L3.4479 8.56121C3.63639 7.46448 4.58993 6.65872 5.68761 6.65872H20.1681L20.0905 7.28543C19.8909 9.02005 18.4384 10.3182 16.7198 10.3182Z",
    fill: "#006AB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3499 16.5517L1.99561 16.6077L2.59434 13.1832H18.993L18.3499 16.5517Z",
    fill: "#006AB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68323 10.3182C7.09558 10.1839 6.51902 10.5421 6.36379 11.124L6.04225 13.1832H2.59399L3.1262 10.3182H7.68323Z",
    fill: "#006AB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9776 2.1263L20.1571 6.65871L14.4581 7.18469L14.6244 6.65871H15.7664C16.3873 6.65871 16.9084 6.18868 16.9861 5.57317L17.0969 4.6555C17.1635 4.16309 16.8087 3.71544 16.3319 3.65949C16.2986 3.65949 16.2543 3.6483 16.221 3.6483H15.5668L16.0547 2.11511L20.9776 2.1263Z",
    fill: "#006AB3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0146,
    cy: 16.7391,
    r: 4.56522,
    fill: "white",
    stroke: "#006AB3",
    strokeWidth: 0.608696
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5248 18.4261H11.9426C11.8446 18.4261 11.7674 18.392 11.711 18.3237C11.6517 18.2525 11.6309 18.1679 11.6487 18.0699L12.1117 15.4877H12.735L12.3522 17.6247C12.3433 17.6722 12.3522 17.7137 12.3789 17.7494C12.4085 17.785 12.4486 17.8028 12.4991 17.8028H14.6361L14.5248 18.4261ZM17.49 18.4261H16.8667L17.1517 16.8233L16.1188 18.4261H15.9229L15.4598 16.8233L15.1749 18.4261H14.5516L15.077 15.4877H15.7003L16.2212 17.2997L17.3921 15.4877H18.0154L17.49 18.4261Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2CLaunch);
export default __webpack_public_path__ + "static/media/m2c-launch.05d15943b8aee53b309c2a93734ea47b.svg";
export { ForwardRef as ReactComponent };